import PropTypes from 'prop-types';
export var variants = {
  ATTENTION: 'attention',
  INFORMATIVE: 'informative',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  BRAND: 'brand',
  ACCENT: 'accent',
  MAGENTA: 'special',
  NULL: ''
};
export var variantsPropType = PropTypes.oneOf(Object.values(variants));